import React from "react";
import Hero from "../components/Hero";
import Button from "../components/Button";
import HomeService from "../assets/img/homeservice.png";
import Img1 from "../assets/img/acc.png";
import Img2 from "../assets/img/acc1.png";
import Accordion from "../components/Accordion";
import Start from "../assets/img/start.svg";
import Execute from "../assets/img/execute.svg";
import Craft from "../assets/img/craft.svg";
import Steps from "../components/Steps";
import { Link } from "react-router-dom";

const Home = () => {
  const steps = [
    {
      img: Start,
      title: "Start Project",
      desc: "Embark on your design adventure by initiating your project. Share your vision and set the stage for a bespoke design experience",
    },
    {
      img: Craft,
      title: "Craft",
      desc: "Collaborate closely to achieve design excellence refining your vision and crafting brilliance into every aspect of your space",
    },
    {
      img: Execute,
      title: "Execute",
      desc: "Witness your vision becoming a reality as we execute the design plan with precision. Celebrate the joy of your newly transformed space",
    },
  ];
  const data = [
    {
      title: "Personalized Design Approach",
      content:
        "We tailor every design element to reflect your individual taste, lifestyle, and personality, ensuring your space feels truly yours—from mood boards to final finishes.",
    },
    {
      title: " Craftsmanship with Precision",
      content:
        "Our team combines skilled artistry with technical expertise to execute your vision flawlessly, delivering high-quality, detail-oriented interiors that stand the test of time.",
    },
  ];
  return (
    <>
      <div className="container section">
        <div className="pb-4">
          <Hero />
        </div>
        {/* Section 1 */}
        <div className="ptb-4">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h2 className="pb-3 heading">Our Services</h2>
              <h4 className="subheading">
                {" "}
                From Concept to Completion, Seamlessly Delivered
              </h4>
              <p>
                At Yanaa Homes, we believe interiors should reflect more than
                style—they should echo your lifestyle and aspirations. We go
                beyond aesthetics to deliver a comprehensive, end-to-end
                solution tailored to your needs. Our turnkey interior services
                are designed to simplify the process, ensuring every step—from
                vision to reality—is smooth, transparent, and well-orchestrated.
              </p>

              {/* <Button
                to="/services"
                title="View All Services"
                className="btn primary"
              /> */}
              <Link to="/services" className="btn primary">
                View All Services
              </Link>
            </div>
            <div className="col-md-4">
              <img src={HomeService} alt="" className="img-fuild w-100" />
            </div>
          </div>
        </div>
        {/* Section 2 */}
        <div className="ptb-4">
          <div className="row align-items-center">
            <div className="col-md-6">
              <img src={Img1} alt="" className="img-fuild w-100" />
            </div>
            <div className="col-md-6">
              <h2 className="pb-3 heading">
                Designing Your Dream With Brilliance
              </h2>
              <p>
                Elevate your spaces with bespoke interior designs that reflect
                your unique style and aspirations, crafted with precision and
                brilliance for an unforgettable living experience
              </p>
              <Accordion items={data} />

              <Button
                to="https://wa.me/917022851682/"
                title="Start Project"
                className="btn primary"
              />
            </div>
          </div>
        </div>
        {/* Section 3 */}
        <div className="ptb-4">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2 className="pb-5 heading">
                Designing Your Dream in Three Simple Steps
              </h2>
              <div className="steps">
                {steps.map((item, index) => (
                  <div key={index} className="pb-3">
                    <Steps img={item.img} title={item.title} desc={item.desc} />
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-6">
              <img src={Img2} alt="" className="img-fuild w-100" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
